import './Reassign.scss';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { loadAppointment, patchAppointment } from 'actions/appointments';
import Button from 'atoms/button';
import Icon from 'atoms/icon';
import toast from 'atoms/toast';
import useQuery from 'hooks/useQuery';
import { refreshAppointments } from 'organisms/Appointments/AppointmentActions/util';
import ReassignDrawerLoader from 'organisms/Loaders/ReassignDrawerLoader';
import {
  appointmentFailure,
  appointmentRequest,
  appointmentSuccess,
} from 'store/reducers/appointment';
import {
  closeDrawer,
  requestFulfilled,
  requestOngoing,
} from 'store/reducers/ui';
import { isPastDateTime } from 'util';

import GroomerInfo from '../GroomerInfo';
import PetServiceInfo from '../PetServiceInfo';
import AvailableGroomerSelect from './AvailableGroomerSelect';

export default function ReassignDrawer() {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = useQuery();
  const { uuid: appointmentUuid } = useSelector((state) => state.ui.drawer);
  const appointment = useSelector((state) => state.appointment);
  const {
    uuid,
    animal,
    dateStart,
    location: appointmentLocation,
    locationUser,
    service,
    note,
    isLoading,
  } = appointment;
  const [selectedGroomer, setSelectedGroomer] = useState('');

  useEffect(() => {
    dispatch(
      loadAppointment({
        apuid: appointmentUuid,
        actions: [appointmentRequest, appointmentSuccess, appointmentFailure],
      })
    );
  }, []);

  const onSendReassign = () => {
    if (!!appointment && !isLoading && !!selectedGroomer) {
      dispatch(requestOngoing());
      dispatch(
        patchAppointment(
          uuid,
          {
            uuid: {
              animal: animal?.uuid,
              location: appointmentLocation?.uuid,
              location_user: selectedGroomer,
              service: service?.uuid,
            },
            date_start: dateStart,
            note,
          },
          isPastDateTime(dateStart)
        )
      ).then(({ success }) => {
        if (success) {
          refreshAppointments({
            location,
            query,
            dispatch,
            auid: animal?.uuid,
          });
          toast({ text: 'Appointment reassigned!' });
          dispatch(closeDrawer());
        }
        dispatch(requestFulfilled());
      });
    }
  };

  if (isLoading)
    return (
      <div className="reassign-drawer">
        <ReassignDrawerLoader />
      </div>
    );

  return (
    <div className="reassign-drawer flex-column">
      <div className="w-100">
        <div className="flex-row justify-between mb-15">
          <h2 className="f26">Reassign appointment</h2>
        </div>
        <GroomerInfo />
        <PetServiceInfo />
        <AvailableGroomerSelect
          luid={appointmentLocation?.uuid}
          dateStart={dateStart}
          animalType={animal?.type}
          selectedGroomer={selectedGroomer}
          setSelectedGroomer={setSelectedGroomer}
          currentGroomerUuid={locationUser?.uuid}
        />
        <div className="flex-row w-100 justify-end">
          <Button
            size="medium"
            onClick={onSendReassign}
            text="Confirm"
            disabled={!selectedGroomer}
            className="confirm-button"
          />
        </div>
      </div>
    </div>
  );
}
